// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.up-blog-grid-layout {
    width: "100%";
    display: flex;
    flex-direction: row;
    height: "1000px";
}

.up-blog-grid-upper {
    display: flex;
    flex-direction: row;
    overflow: "hidden";
}

.up-blog-grid-lower {
    overflow: "hidden";
    display: flex;
    flex-direction: row;
    gap: 20px;
}

.up-profile-card {
    margin-top: 10px;
    width: 200px;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    text-align: center;
    transition: transform 0.3s ease-in-out;
    background: rgb(34, 31, 31);
    margin-left: 10px;
  }
  
  .up-profile-card:hover {
    transform: scale(1.05); /* Subtle hover effect */
  }
  
  .up-profile {
    width: 90%;
    height: 50%;
    background: none;
    padding: 10px;
  }

  .up-image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .up-details {
    width: 100%;
    height: 40%;
    background: none;
    padding: 10px;
  }
  
  .up-details h4 {
    margin: 5px 0;
    font-size: 16px;
    font-weight: bold;
  }

  .up-text-label {
    
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/Blogging.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,sBAAsB,EAAE,wBAAwB;EAClD;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;;EAEA;;EAEA","sourcesContent":[".up-blog-grid-layout {\n    width: \"100%\";\n    display: flex;\n    flex-direction: row;\n    height: \"1000px\";\n}\n\n.up-blog-grid-upper {\n    display: flex;\n    flex-direction: row;\n    overflow: \"hidden\";\n}\n\n.up-blog-grid-lower {\n    overflow: \"hidden\";\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n}\n\n.up-profile-card {\n    margin-top: 10px;\n    width: 200px;\n    height: 200px;\n    border-radius: 12px;\n    overflow: hidden;\n    text-align: center;\n    transition: transform 0.3s ease-in-out;\n    background: rgb(34, 31, 31);\n    margin-left: 10px;\n  }\n  \n  .up-profile-card:hover {\n    transform: scale(1.05); /* Subtle hover effect */\n  }\n  \n  .up-profile {\n    width: 90%;\n    height: 50%;\n    background: none;\n    padding: 10px;\n  }\n\n  .up-image {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  \n  .up-details {\n    width: 100%;\n    height: 40%;\n    background: none;\n    padding: 10px;\n  }\n  \n  .up-details h4 {\n    margin: 5px 0;\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  .up-text-label {\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
